export default "/images/main_page_mock_preview.webp"